import React from 'react';
import { CollapsableFilters } from './collapsable-filters';
import { GTINListFilter } from '@/hooks/use-gtin-metadata-filters';

interface Props {
  listFilter: GTINListFilter;
}

export const CollapsableGTINFilterList: React.FC<Props> = ({ listFilter }) => {
  return (
    <CollapsableFilters
      label={listFilter.label}
      onSelect={listFilter.updateFilter}
      options={listFilter.options}
      selected={listFilter.filter}
    />
  );
};
